export default "__VITE_ASSET__DUlY1kRr__"